(() => {
  if (window.hcExperienceLoaded) return;
  window.hcExperienceLoaded = true;
  let opener = null;
  let previousOverflow = '';
  const project = () => document.getElementById('hc-project');
  function openProject(trigger) {
    const panel = project();
    if (!panel || panel.open) return;
    opener = trigger || document.activeElement;
    const context = trigger?.dataset.hcProduct || document.querySelector('[data-hc-product-title]')?.dataset.hcProductTitle || trigger?.dataset.hcInterest || '';
    const contextLabel = panel.querySelector('[data-hc-zoho-context]');
    if (contextLabel) {
      contextLabel.textContent = context ? `Vous consultez : ${context}` : '';
      contextLabel.hidden = !context;
    }
    const frame = panel.querySelector('[data-hc-zoho-frame]');
    if (frame) {
      const serviceRequest = trigger?.hasAttribute('data-hc-service');
      const formUrl = serviceRequest ? trigger.href : frame.dataset.src;
      const title = panel.querySelector('#hc-project-title');
      if (title && !title.dataset.hcDefaultTitle) title.dataset.hcDefaultTitle = title.textContent;
      const formTitle = serviceRequest ? trigger.dataset.hcFormTitle : title?.dataset.hcDefaultTitle;
      if (title && formTitle) title.textContent = formTitle;
      if (formTitle) {
        frame.title = formTitle + ' · Piscine Hippocampe';
        frame.setAttribute('aria-label', formTitle);
      }
      const fallback = panel.querySelector('.hc-zoho-footer a[target="_blank"]');
      if (fallback) fallback.href = formUrl;
      if (frame.getAttribute('src') !== formUrl) frame.src = formUrl;
    }
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panel.dataset.hcModal = '';
    panel.showModal();
    panel.querySelector('[data-hc-close]')?.focus();
  }
  function closeProject() {
    const panel = project();
    if (panel?.open) panel.close();
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-hc-spa]').forEach(root => {
      if (root.dataset.hcSpaInitialized) return;
      root.dataset.hcSpaInitialized = 'true';
      const select = root.querySelector('[data-hc-spa-filter]');
      const models = [...root.querySelectorAll('[data-hc-spa-model]')];
      function filter(value) {
        select.value = value;
        models.forEach(model => { model.hidden = value !== 'all' && model.dataset.hcSpaModel !== value; });
        const count = models.filter(model => !model.hidden).length;
        root.querySelector('[data-hc-spa-count]').textContent = document.documentElement.lang.startsWith('en') ? `${count} model${count === 1 ? '' : 's'} shown` : `${count} modèle${count === 1 ? '' : 's'} présenté${count === 1 ? '' : 's'}`;
        root.querySelector('[data-hc-spa-empty]').hidden = count > 0;
      }
      root.querySelector('[data-hc-spa-filters]').hidden = false;
      select.addEventListener('change', () => filter(select.value));
      root.querySelectorAll('[data-hc-spa-shortcut]').forEach(a => a.addEventListener('click', () => filter(a.dataset.hcSpaShortcut)));
      root.addEventListener('shopify:block:select', e => {
        const block = models.find(model => model.dataset.hcSpaBlock === e.detail?.blockId);
        if (block?.hasAttribute('data-hc-spa-model')) filter(block.dataset.hcSpaModel);
      });
      filter('all');
    });

    scope.querySelectorAll('[data-hc-shop]').forEach(root => {
      if (root.dataset.hcShopInitialized) return;
      root.dataset.hcShopInitialized = 'true';
      const tabs = [...root.querySelectorAll('[data-hc-shop-tab]')];
      const groups = [...root.querySelectorAll('[data-hc-shop-group]')];
      const cards = [...root.querySelectorAll('[data-hc-shop-card]')];
      const details = [...root.querySelectorAll('[data-hc-shop-detail]')];
      const selected = {};
      function chooseCard(id, toggle = false) {
        const card = cards.find(c => c.dataset.hcShopCard === id);
        if (!card) return;
        const group = card.dataset.hcGroup;
        const activeId = toggle && card.getAttribute('aria-expanded') === 'true' ? null : id;
        selected[group] = activeId;
        cards.filter(c => c.dataset.hcGroup === group).forEach(c => {
          const expanded = c.dataset.hcShopCard === activeId;
          c.setAttribute('aria-expanded', String(expanded));
        });
        const panel = groups.find(g => g.dataset.hcShopGroup === group);
        panel?.querySelectorAll('[data-hc-shop-detail]').forEach(d => { d.hidden = d.dataset.hcShopDetail !== activeId; });
      }
      function chooseGroup(id) {
        groups.forEach(g => { g.hidden = g.dataset.hcShopGroup !== id; });
        tabs.forEach(t => { const active = t.dataset.hcShopTab === id; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
        if (selected[id]) chooseCard(selected[id]);
      }
      root.querySelector('.hc-shop-tabs')?.setAttribute('role', 'tablist');
      groups.forEach(g => g.setAttribute('role', 'tabpanel'));
      tabs.forEach((t, i) => {
        t.setAttribute('role', 'tab'); t.setAttribute('aria-controls', t.hash.slice(1));
        t.addEventListener('click', e => { e.preventDefault(); chooseGroup(t.dataset.hcShopTab); });
        t.addEventListener('keydown', e => {
          let next;
          if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (e.key === ' ') next = i;
          if (next === undefined) return;
          e.preventDefault(); tabs[next].focus(); chooseGroup(tabs[next].dataset.hcShopTab);
        });
      });
      cards.forEach(c => {
        c.setAttribute('role', 'button'); c.setAttribute('aria-expanded', 'false');
        c.addEventListener('click', e => { e.preventDefault(); chooseCard(c.dataset.hcShopCard, true); });
        c.addEventListener('keydown', e => { if (e.key === ' ') { e.preventDefault(); chooseCard(c.dataset.hcShopCard, true); } });
      });
      details.forEach(d => { d.hidden = true; d.setAttribute('role', 'region'); });
      root.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const detail = e.target.closest('[data-hc-shop-detail]');
        if (!detail || detail.hidden) return;
        const card = cards.find(c => c.dataset.hcShopCard === detail.dataset.hcShopDetail);
        if (card) { chooseCard(card.dataset.hcShopCard, true); card.focus({preventScroll:true}); }
      });
      if (tabs.length) chooseGroup(tabs[0].dataset.hcShopTab);
      root.addEventListener('shopify:block:select', e => {
        const card = cards.find(c => c.dataset.hcShopCard === e.detail?.blockId);
        if (card) { chooseGroup(card.dataset.hcGroup); chooseCard(card.dataset.hcShopCard); }
      });
    });

    scope.querySelectorAll('[data-hc-universes]').forEach(root => {
      if (root.dataset.hcInitialized) return;
      root.dataset.hcInitialized = 'true';
      const choices = [...root.querySelectorAll('[data-hc-universe]')];
      const panels = [...root.querySelectorAll('[data-hc-panel]')];
      const list = root.querySelector('.hc-universe-list');
      const previous = root.querySelector('[data-hc-universe-prev]');
      const next = root.querySelector('[data-hc-universe-next]');
      const mobileNavigation = window.matchMedia('(max-width: 760px)');
      let current = 0;
      const reveal = choice => {
        if (!choice || !list || list.scrollWidth <= list.clientWidth) return;
        // Scroll the photo rail only; keep the customer's page position.
        const offset = choice.getBoundingClientRect().left - list.getBoundingClientRect().left;
        list.scrollTo?.({left: list.scrollLeft + offset - (list.clientWidth - choice.offsetWidth) / 2, behavior: 'auto'});
      };
      const choose = (id, scroll = false) => {
        const index = choices.findIndex(a => a.dataset.hcUniverse === id);
        if (index < 0) return;
        current = index;
        panels.forEach(p => { p.hidden = p.dataset.hcPanel !== id; });
        choices.forEach(a => {
          const active = a.dataset.hcUniverse === id;
          a.setAttribute('aria-current', String(active));
          a.setAttribute('aria-selected', String(active));
          a.tabIndex = active ? 0 : -1;
        });
        if (previous) previous.disabled = current === 0;
        if (next) next.disabled = current === choices.length - 1;
        if (scroll) reveal(choices[current]);
      };
      list?.setAttribute('role', 'tablist');
      panels.forEach(p => { p.setAttribute('role', 'tabpanel'); p.tabIndex = 0; });
      choices.forEach((a, index) => {
        a.setAttribute('role', 'tab');
        a.id = `hc-universe-tab-${root.id}-${a.dataset.hcUniverse}`;
        const panel = panels.find(p => p.dataset.hcPanel === a.dataset.hcUniverse);
        panel?.setAttribute('aria-labelledby', a.id);
        a.addEventListener('click', e => {
          if (mobileNavigation.matches) return;
          e.preventDefault(); choose(a.dataset.hcUniverse, true);
        });
        a.addEventListener('keydown', e => {
          if (mobileNavigation.matches) return;
          let target;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') target = (index + 1) % choices.length;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') target = (index + choices.length - 1) % choices.length;
          if (e.key === 'Home') target = 0;
          if (e.key === 'End') target = choices.length - 1;
          if (e.key === ' ') target = index;
          if (target === undefined) return;
          e.preventDefault();
          choose(choices[target].dataset.hcUniverse, true);
          choices[target].focus({preventScroll: true});
        });
      });
      const controls = root.querySelector('[data-hc-universe-controls]');
      if (controls) controls.hidden = choices.length < 2;
      previous?.addEventListener('click', () => choose(choices[Math.max(0, current - 1)]?.dataset.hcUniverse, true));
      next?.addEventListener('click', () => choose(choices[Math.min(choices.length - 1, current + 1)]?.dataset.hcUniverse, true));
      root.querySelector('.hc-universe-panels').dataset.hcReady = '';
      const updateNavigationMode = () => {
        const mobile = mobileNavigation.matches;
        if (list) list.setAttribute('role', mobile ? 'navigation' : 'tablist');
        if (choices.length) choose(choices[current].dataset.hcUniverse);
        choices.forEach(a => {
          a.href = mobile ? a.dataset.hcMobileUrl : `#hc-universe-${a.dataset.hcUniverse}`;
          if (mobile) {
            a.removeAttribute('role');
            a.removeAttribute('aria-current');
            a.removeAttribute('aria-selected');
            a.removeAttribute('aria-controls');
            a.tabIndex = 0;
          } else {
            a.setAttribute('role', 'tab');
            a.setAttribute('aria-controls', `hc-universe-${a.dataset.hcUniverse}`);
          }
        });
      };
      mobileNavigation.addEventListener('change', updateNavigationMode);
      updateNavigationMode();
      root.addEventListener('shopify:block:select', e => {
        if (!mobileNavigation.matches) choose(e.detail?.blockId, true);
      });
    });
    const panel = project();
    if (panel && !panel.dataset.hcInitialized) {
      panel.dataset.hcInitialized = 'true';
      panel.addEventListener('close', () => {
        panel.removeAttribute('data-hc-modal');
        document.body.style.overflow = previousOverflow;
        if (opener?.isConnected) opener.focus();
      });
      if (window.location.hash === '#hc-project') openProject(null);
    }
  }
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-hc-inquiry], a[href="#hc-project"]');
    if (trigger && project()) { e.preventDefault(); openProject(trigger); }
    if (e.target.closest('[data-hc-close]')) closeProject();
    const panel = project();
    if (e.target === panel && panel?.open) {
      const bounds = panel.getBoundingClientRect();
      if (e.clientX < bounds.left || e.clientX > bounds.right || e.clientY < bounds.top || e.clientY > bounds.bottom) closeProject();
    }
  });
  window.addEventListener('hashchange', () => {
    if (window.location.hash === '#hc-project') openProject(null);
  });
  document.addEventListener('shopify:section:load', e => init(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();

